module.exports = __webpack_public_path__ + "img/photo-02.a75ac85b.jpg";